import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { ConfirmPaymentRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { ConfirmPaymentResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const confirmPayment = (request: ConfirmPaymentRequest, options?: CashRequestOptions) =>
  post<ConfirmPaymentRequest, ConfirmPaymentResponse>('/2.0/cash/confirm-payment', request, {
    ...options,
    rejectOnError: true,
  })
